import React from "react";
import SectionTag from "./style";

const Section = ({ children, className }) => {
  const addAllClasses = [" "];
  if (className) {
    addAllClasses.push(className);
  }
  return (
    <SectionTag className={addAllClasses.join(" ")}>{children}</SectionTag>
  );
};

export default Section;
